export class TranslatableError extends Error {
  entityType?: string;

  constructor(message: string, entityType?: string) {
    super(message);
    this.entityType = entityType;
  }
}
